import { Modal } from "shared/ui/modal";
import { Button } from "shared/ui/button";
import styles from "./RecordDeleteConfirmModal.module.scss";

export const RecordDeleteConfirmModal = ({
  isModalOpen,
  open,
  close,
  toggle,
  onConfirm,
}) => {
  return (
    <Modal isModalOpen={isModalOpen} open={open} close={close} toggle={toggle}>
      <div className={styles.modalContent}>
        <p className={styles.modalContent__title}>
          Вы уверены,что хотите отменить запись на мероприятие?
        </p>
        <div className={styles.modalContent__button}>
          <Button variant="outlineGreen" size="large" onClick={close}>
            Нет
          </Button>
          <Button variant="primary" size="large" onClick={onConfirm}>
            Да
          </Button>
        </div>
      </div>
    </Modal>
  );
};
